/* ══════════════════════════════════════════════════════════════════
   📍 PINCODE-CHANGE CART RECHECK — Standalone/Global Script
   ══════════════════════════════════════════════════════════════════
   Loaded ONCE, globally, via <script defer> in layout/theme.liquid —
   same pattern as sleep-setup-widget.js and free-gift.js.

   ══════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  if (window.__swPincodeRecheckInit) return;
  window.__swPincodeRecheckInit = true;

  console.log('📍 Pincode-change cart recheck — active');

  var DELIVERY_API_URL = 'https://sf-backend.mysleepwell.com/s1/product/citybypincode';
  var PRICE_API_URL    = 'https://sf-backend.mysleepwell.com/apis/shopify/price/update';

  var API_TIMEOUT_MS   = 6000;
  // Max cart lines processed at once. Faster than fully sequential,
  // gentle enough on the backend that a large cart won't fire all its
  // calls simultaneously.
  var MAX_CONCURRENCY  = 3;

  function fetchWithTimeout(url, options, timeoutMs) {
    options = options || {};
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, timeoutMs || API_TIMEOUT_MS);
    var merged = Object.assign({}, options, { signal: controller.signal });
    return fetch(url, merged).finally(function () { clearTimeout(timer); });
  }

   // Runs `worker(item)` for every item, but never more than `limit`
  // in flight at once. Resolves once all are done. Errors in a single
  // worker are swallowed so one bad item can't stall the whole pass.
  function runWithConcurrency(items, limit, worker) {
    return new Promise(function (resolve) {
      var i = 0, active = 0, done = 0;
      var total = items.length;
      if (!total) { resolve(); return; }
      function next() {
        while (active < limit && i < total) {
          let item = items[i++];
          active++;
          Promise.resolve().then(function () { return worker(item); })
            .catch(function () {})
            .then(function () {
              active--; done++;
              if (done === total) resolve();
              else next();
            });
        }
      }
      next();
    });
  }

  function showPincodeToast(msg, isError) {
    var t = document.querySelector('.sw-pincode-toast');
    if (t) t.remove();
    t = document.createElement('div');
    t.className = 'sw-pincode-toast';
    t.style.cssText =
      'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);' +
      'background:' + (isError ? '#cc0000' : '#28a745') + ';color:#fff;padding:12px 20px;' +
      'border-radius:8px;z-index:99999;font-size:14px;font-weight:600;' +
      'box-shadow:0 4px 12px rgba(0,0,0,.15);max-width:90vw;text-align:center;';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () {
      t.style.transition = 'opacity 0.3s ease';
      t.style.opacity = '0';
      setTimeout(function () { t.remove(); }, 300);
    }, 4500);
  }

  function setCheckoutBusy(isBusy) {
    document.querySelectorAll('.gokwik-checkout').forEach(function (el) {
      el.classList.toggle('sw-checkout-busy', !!isBusy);
    });
  }

  // Format a delivery-days offset into the "TUE APR 14 2026" style
  // string. Delegates to sleep-setup-widget.js's global formatter when
  // present so the format never drifts between the two scripts; falls
  // back to a local copy otherwise.
  function formatDeliveryDate(days) {
    if (typeof window.__swFormatDeliveryDate === 'function') {
      return window.__swFormatDeliveryDate(days);
    }
    var d = new Date();
    d.setDate(d.getDate() + (parseInt(days, 10) || 0));
    var parts = d.toDateString().split(' ');
    parts[0] = parts[0].toUpperCase();
    return parts.join(' ');
  }

  // Build the "Estimated delivery on <date>" TAT string from a
  // citybypincode `record` — same custom-vs-standard day-selection
  // logic the delivery-estimate UI uses. Returns '' when no usable
  // delivery days are present, so we never stamp a meaningless TAT.
  function buildDeliveryTat(record) {
    if (!record) return '';
    var isCustom = (function () {
      try { return sessionStorage.getItem('isCustomSize') === '1'; } catch (e) { return false; }
    })();
    var days = isCustom
      ? (record.omni_custom_delivery != null ? record.omni_custom_delivery : record.omni_standard_delivery)
      : record.omni_standard_delivery;
    if (days == null) return '';
    return 'Estimated delivery on ' + formatDeliveryDate(days);
  }

 function checkServiceability(pid, dims, qty, pincode) {
    var thk = (dims.thickness != null && !isNaN(dims.thickness)) ? dims.thickness : 6;
    var url = DELIVERY_API_URL + '/' + pincode + '/' + pid +
      '?l=' + (dims.length || 72) + '&b=' + (dims.breadth || 30) + '&t=' + thk +
      '&q=' + (qty || 1) + '&_=' + Date.now();

    return fetchWithTimeout(url, {}, API_TIMEOUT_MS)
      .then(function (res) {
        if (!res.ok) throw new Error('citybypincode status ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var record = Array.isArray(data) ? data[0] : data;
        if (!record) return { serviceable: false, record: null };
        var serviceable = record.isExits === 1 && record.dstatus === 1;
        return { serviceable: serviceable, record: record };
      })
      .catch(function (e) {
        console.error('📍 citybypincode check failed for pid', pid, ':', e);
        return { serviceable: false, record: null };
      });
  }
  
function fetchNewPrice(item, cityId, stateId) {
    if (item.properties && item.properties['_is_free_gift'] === 'true') {
      console.error('📍 🛑 fetchNewPrice: FREE GIFT item ke liye call hua — refuse kiya.');
      return Promise.resolve(null);
    }
    var productId = item.properties['_product_id'];
var length    = parseFloat(item.properties['_length'])    || 72;
var breadth   = parseFloat(item.properties['_breadth'])   || 30;
var rawThk = parseFloat(item.properties['_thickness']);
var thickness = !isNaN(rawThk) ? rawThk : 0;
var qty       = parseInt(item.quantity, 10) || 1;
var category  = item.properties['_sw_category'] || ''; 

    var req = {
      productId: productId,
      variantId: item.variant_id,
      cityId:    cityId,
      stateId:   stateId,
      length:    length,
      breadth:   breadth,
      thickness: thickness,
      type: 1,
      quantity: qty,
      category: category
    };

    return fetchWithTimeout(PRICE_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(req)
    }, API_TIMEOUT_MS)
      .then(function (res) {
        if (!res.ok) throw new Error('price/update status ' + res.status);
        return res.json();
      })
      .catch(function (e) {
        console.error('📍 price/update failed for pid', productId, ':', e);
        return null;
      });
  }

  // ════════════════════════════════════════════════════════════════
  // 🆕 REUSABLE MERGE — merges duplicate cart lines that share the
  // same `_product_id` + `_length` + `_breadth` + `_thickness` (all
  // rounded/normalized) into ONE line with the combined quantity.
  // These four values are exactly what the price/update API uses to
  // price a product for a given pincode, so a match here guarantees
  // identical pricing — regardless of which Shopify variant_id was
  // resolved, or whether other properties (e.g. `_variant_id`,
  // `_color`, `hl_pin`) differ between the two lines because they
  // were added via different flows (PDP vs Sleep Essentials vs
  // Compare vs Collection PLP) with different property sets.
  //
  // Exposed globally (window.__swMergeDuplicateCartLines) so any
  // add-to-cart flow across the theme can call it immediately after a
  // successful /cart/add.js — duplicates no longer have to wait for a
  // pincode change to be cleaned up.
  //
  // `preferredPincode` (optional) — when merging as part of a
  // pincode-recheck pass, prefer keeping the line whose `hl_pin`
  // already matches the pincode just processed; otherwise the first
  // line found survives.
  // ════════════════════════════════════════════════════════════════
  function mergeDuplicateCartLines(preferredPincode) {
    return (window.__swGetCart ? window.__swGetCart(true) : fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }))
      .then(function (freshCart) {
        var freshRealItems = (freshCart.items || []).filter(function (it) {
          return !(it.properties && it.properties['_is_free_gift'] === 'true') &&
                 it.properties && it.properties['_product_id'];
        });

        // Simple, deliberate merge key: product_id + length + breadth +
        // thickness only. Thickness is rounded here too, matching the
        // normalization used everywhere else in this file, so a stray
        // API decimal never prevents two otherwise-identical lines from
        // being recognized as duplicates.
        var groups = {};
        freshRealItems.forEach(function (it) {
          var p = it.properties || {};
          var groupKey = String(p['_product_id'] || '') + '::' +
                          String(parseInt(p['_length'], 10)  || 0) + '::' +
                          String(parseInt(p['_breadth'], 10) || 0) + '::' +
                         String(parseFloat(p['_thickness']) || 0);
          if (!groups[groupKey]) groups[groupKey] = [];
          groups[groupKey].push(it);
        });

        var mergeOps = [];
        var mergedCount = 0;
        Object.keys(groups).forEach(function (groupKey) {
          var lines = groups[groupKey];
          if (lines.length < 2) return; // no duplicate for this product/config

          var survivorIdx = preferredPincode
            ? lines.findIndex(function (it) { return it.properties && String(it.properties['hl_pin']) === String(preferredPincode); })
            : -1;
          if (survivorIdx === -1) survivorIdx = 0;

          var survivor = lines[survivorIdx];
          var totalQty = lines.reduce(function (sum, it) { return sum + (parseInt(it.quantity, 10) || 0); }, 0);
          var toRemove = lines.filter(function (it) { return it.key !== survivor.key; });

          console.log('📍 Merging', lines.length, 'duplicate line(s) for group', groupKey, '— combined qty:', totalQty);
          mergedCount++;

          mergeOps.push(
            fetch('/cart/change.js', {
              method: 'POST',
              cache: 'no-store',
              headers: { 'Content-Type': 'application/json', 'X-SW-Silent-Cart-Sync': '1' },
              body: JSON.stringify({ id: survivor.key, quantity: totalQty })
            }).then(function () {
              return Promise.all(toRemove.map(function (it) {
                return fetch('/cart/change.js', {
                  method: 'POST',
                  cache: 'no-store',
                  headers: { 'Content-Type': 'application/json', 'X-SW-Silent-Cart-Sync': '1' },
                  body: JSON.stringify({ id: it.key, quantity: 0 })
                });
              }));
            }).catch(function (e) {
              console.error('📍 Failed to merge duplicate lines for group', groupKey, ':', e);
            })
          );
        });

        if (!mergeOps.length) return 0;
        return Promise.all(mergeOps).then(function () { return mergedCount; });
      })
      .catch(function (e) {
        console.error('📍 mergeDuplicateCartLines failed:', e);
        return 0;
      });
  }
  window.__swMergeDuplicateCartLines = mergeDuplicateCartLines;

  var recheckInFlight = false;
  var recheckQueuedPincode = null;
  var lastCheckedPincode = null;

  function recheckAllCartItemsForPincode(pincode) {
    if (!pincode || !/^\d{6}$/.test(pincode)) return Promise.resolve();

    if (recheckInFlight) {
      recheckQueuedPincode = pincode;
      return Promise.resolve();
    }
    recheckInFlight = true;
    setCheckoutBusy(true);

    return (window.__swGetCart ? window.__swGetCart(true) : fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }))
      .then(function (cart) {
        // Only real, priced items (gift lines are never independently
        // re-priced/removed here — they follow their parent mattress
        // via free-gift.js's own reconciliation).
        var realItems = (cart.items || []).filter(function (it) {
          return !(it.properties && it.properties['_is_free_gift'] === 'true');
        });

        if (!realItems.length) return;

        var removedTitles = [];
        var notAvailableTitles = [];
        var updatedCount = 0;

       var chain = runWithConcurrency(realItems, MAX_CONCURRENCY, function (item) {
          return Promise.resolve().then(function () {
            // 🆕 _product_id hi nahi hai — pehle ye silently ignore ho
            // jaata tha (filter se hi bahar). Ab explicitly Not Available +
            // incomplete mark karo taaki UI banner dikhaye aur checkout gate
            // (swGoToCheckout) ise pakad le.
            if (!(item.properties && item.properties['_product_id'])) {
              notAvailableTitles.push(item.product_title || item.title);
              console.error('📍 "' + (item.product_title || item.title) + '" has no _product_id — marking incomplete.');
              var incompleteProps = Object.assign({}, item.properties || {}, {
                '_not_available': 'true',
                '_props_incomplete': 'true'
              });
              updatedCount++;
              return fetch('/cart/change.js', {
                method: 'POST',
                cache: 'no-store',
                headers: { 'Content-Type': 'application/json', 'X-SW-Silent-Cart-Sync': '1' },
                body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: incompleteProps })
              }).catch(function (e) {
                console.error('📍 Failed to mark incomplete item Not Available', item.key, ':', e);
              });
            }

var productId = item.properties['_product_id'];
var rawThk2 = parseFloat(item.properties['_thickness']);
var dims = {
  length:    item.properties['_length'],
  breadth:   item.properties['_breadth'],
  thickness: !isNaN(rawThk2) ? rawThk2 : 0
};
            var qty = parseInt(item.quantity, 10) || 1;
            return checkServiceability(productId, dims, qty, pincode).then(function (result) {
              if (!result.serviceable) {
                notAvailableTitles.push(item.product_title || item.title);
                console.warn('📍 "' + (item.product_title || item.title) + '" is NOT serviceable at pincode ' + pincode + ' — marking Not Available (NOT removing from cart).');
                var naPropsUnserviceable = Object.assign({}, item.properties, {
                  '_not_available': 'true'
                });
                updatedCount++;
                return fetch('/cart/change.js', {
                  method: 'POST',
                  cache: 'no-store',
                  headers: { 'Content-Type': 'application/json', 'X-SW-Silent-Cart-Sync': '1' },
                  body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: naPropsUnserviceable })
                }).catch(function (e) {
                  console.error('📍 Failed to mark unserviceable item Not Available', item.key, ':', e);
                });
              }

              var record = result.record;
              var cityId  = record.id;
              var stateId = record.stateId;

              // 🆕 GUARD: citybypincode ne isExits=1/dstatus=1 (serviceable)
              // bola, lekin agar id/stateId hi missing/blank hain, to blank
              // _city_id/_state_id cart line mein kabhi push nahi karna —
              // isko Not Available treat karo (checkout gate isse pakad
              // lega), taaki koi bhi item blank city/state ke saath cart
              // mein kabhi na jaaye.
              if (cityId == null || String(cityId).trim() === '' ||
                  stateId == null || String(stateId).trim() === '') {
                notAvailableTitles.push(item.product_title || item.title);
                console.error('📍 "' + (item.product_title || item.title) + '" — citybypincode record serviceable maana gaya lekin id/stateId missing (id=' + cityId + ', stateId=' + stateId + ') — blank city_id/state_id refuse, Not Available mark kiya.');
                var naPropsMissingLoc = Object.assign({}, item.properties, {
                  '_not_available': 'true'
                });
                updatedCount++;
                return fetch('/cart/change.js', {
                  method: 'POST',
                  cache: 'no-store',
                  headers: { 'Content-Type': 'application/json', 'X-SW-Silent-Cart-Sync': '1' },
                  body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: naPropsMissingLoc })
                }).catch(function (e) {
                  console.error('📍 Failed to mark missing-location item Not Available', item.key, ':', e);
                });
              }

              return fetchNewPrice(item, cityId, stateId).then(function (priceResp) {
                if (!priceResp || !priceResp.success || !priceResp.priceData) {
                  // 🆕 ₹0 GUARD — API fail hui aur is line ka current _api_price
                  // pehle se 0/invalid hai (purane flow se aayi line), to use
                  // unchanged chhodna ₹0 order ka risk hai — Not Available mark
                  // karo taaki checkout gate rok de. Sahi price wali lines pehle
                  // jaisi unchanged rehti hain.
                  var curApiRaw = item.properties['_api_price'];
                  var curApi = parseFloat(curApiRaw);
                  if (curApiRaw != null && String(curApiRaw).trim() !== '' && !(curApi > 0)) {
                    notAvailableTitles.push(item.product_title || item.title);
                    updatedCount++;
                    console.warn('📍 "' + (item.product_title || item.title) + '" — price API failed and current _api_price is ' + curApiRaw + ' — marking Not Available.');
                    return fetch('/cart/change.js', {
                      method: 'POST',
                      cache: 'no-store',
                      headers: { 'Content-Type': 'application/json', 'X-SW-Silent-Cart-Sync': '1' },
                      body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: Object.assign({}, item.properties, { '_not_available': 'true' }) })
                    }).catch(function (e) {
                      console.error('📍 Failed to mark zero-price item Not Available', item.key, ':', e);
                    });
                  }
                  console.warn('📍 Could not fetch new price for "' + (item.product_title || item.title) + '" at pincode ' + pincode + ' — leaving this line unchanged.');
                  return;
                }

                var p = priceResp.priceData;
                var salePrice = Number(p.salePrice);
                if (!(salePrice > 0)) {
                  notAvailableTitles.push(item.product_title || item.title);
                  var naProps = Object.assign({}, item.properties, {
                    '_not_available': 'true'
                  });
                  updatedCount++;
                  console.warn('📍 "' + (item.product_title || item.title) + '" priced at 0 for pincode ' + pincode + ' — marking Not Available (NOT removing from cart).');
                  return fetch('/cart/change.js', {
                    method: 'POST',
                    cache: 'no-store',
                    headers: { 'Content-Type': 'application/json', 'X-SW-Silent-Cart-Sync': '1' },
                    body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: naProps })
                  }).catch(function (e) {
                    console.error('📍 Failed to mark item Not Available', item.key, ':', e);
                  });
                }
                    // 🆕 ===== NAYA BLOCK — _color / _size fullData se nikalna =====
                  // 🆕 ===== NAYA BLOCK — _color / _size / mm dims fullData se nikalna =====
var fd = priceResp.fullData || {};
// 🆕 27-Oct FIX: _color pehle cart line ke apne variant ke "Color" option se
// (gray select kiya to GRAY). Pehle yahan API ke color list ka PEHLA color
// (jaise "BEIGE") lag jaata tha aur PDP ka sahi _color overwrite ho jaata tha.
var newColor = '';
(item.options_with_values || []).forEach(function (o) {
  if (!newColor && o && /^colou?r$/i.test(String(o.name || '').trim()) && o.value) {
    newColor = String(o.value).trim().toUpperCase();
    if (newColor === 'GRAY') newColor = 'GREY'; // 🆕 27-Oct: spelling GREY
  }
});
if (!newColor && fd.color) {
  if (Array.isArray(fd.color) && fd.color.length) newColor = String(fd.color[0]);
  else if (typeof fd.color === 'string' && fd.color) newColor = fd.color;
}
if (!newColor) newColor = item.properties['_color'] || 'Default';

var newSize = fd.size ? String(fd.size) : (item.properties['_size'] || '');

var newLengthMm    = fd.lengthMm    != null ? String(fd.lengthMm)    : (item.properties['_lengthMm']    || '');
var newBreadthMm   = fd.breadthMm   != null ? String(fd.breadthMm)   : (item.properties['_breadthMm']   || '');
var newThicknessMm = fd.thicknessMm != null ? String(fd.thicknessMm) : (item.properties['_thicknessMm'] || '');
// 🆕 ===== NAYA BLOCK END =====

var deliveryTat = buildDeliveryTat(record);
var updatedProps = Object.assign({}, item.properties, {
  '_api_price':    String(p.salePrice    != null ? p.salePrice    : ''),
  '_api_compare':  String(p.comparePrice != null ? p.comparePrice : 0),
  '_api_discount': String(p.discount     != null ? p.discount     : 0),
  '_city_id':      String(cityId  || ''),
  '_city_name':    String(record.city  || ''),
  '_state_id':     String(stateId || ''),
  '_state_name':   String(record.state || ''),
  'hl_pin':        String(pincode),
  '_extra_total':  String(p.extraCharge || 0),
  '_delivery_tat': deliveryTat,
  '_color':        newColor,   
   '_size':         newSize,    
  '_lengthMm':     newLengthMm,       // 🆕
  '_breadthMm':    newBreadthMm,      // 🆕
  '_thicknessMm':  newThicknessMm,    // 🆕
  '_cod_discount': String((fd && fd.cod_discount) || 0),
  '_not_available': 'false'
});

                // 🆕 Properties bilkul same hain to /cart/change.js mat karo —
                // har change.js native cart drawer ko re-render karta hai (flicker).
                var oldProps = item.properties || {};
                var changed = Object.keys(updatedProps).some(function (k) {
                  return String(updatedProps[k]) !== String(oldProps[k] == null ? '' : oldProps[k]);
                });
                if (!changed) {
                  console.log('📍 "' + (item.product_title || item.title) + '" unchanged for pincode ' + pincode + ' — skip write');
                  return;
                }

                updatedCount++;
                console.log('📍 Updated "' + (item.product_title || item.title) + '" for pincode ' + pincode + ': ₹' + p.salePrice + (deliveryTat ? ' | ' + deliveryTat : ''));

                return fetch('/cart/change.js', {
                  method: 'POST',
                  cache: 'no-store',
                  headers: { 'Content-Type': 'application/json', 'X-SW-Silent-Cart-Sync': '1' },
                  body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: updatedProps })
                }).catch(function (e) {
                  console.error('📍 Failed to persist updated price for item', item.key, ':', e);
                });
              });
            });
          });
        });

        return chain.then(function () {
          if (removedTitles.length) {
            showPincodeToast(
              (removedTitles.length === 1 ? removedTitles[0] : removedTitles.length + ' items') +
              ' not available at pincode ' + pincode + ' — removed from cart.',
              true
            );
          }
          if (notAvailableTitles.length) {
            var naMsg = notAvailableTitles.length === 1
              ? '"' + notAvailableTitles[0] + '" is not available at pincode ' + pincode + '. Please select another product.'
              : notAvailableTitles.map(function (t) { return '"' + t + '"'; }).join(', ') +
                ' are not available at pincode ' + pincode + '. Please select another product.';
            showPincodeToast(naMsg, true);
          }

          // 🆕 Duplicate-merge now delegates to the shared, simplified
          // mergeDuplicateCartLines() (product_id + length + breadth +
          // thickness key) instead of an inline block keyed on variant_id
          // — see the function's own header comment for why.
          return mergeDuplicateCartLines(pincode)
            .then(function (mergedCount) {
              updatedCount += mergedCount;
            })
            .catch(function (e) {
              console.error('📍 Duplicate-merge pass failed:', e);
            })
            .then(function () {
              // Gift lines don't get their own price/serviceability
              // check above — copy each gift's PARENT product's
              // _delivery_tat onto it, matched via _gift_for_variant_ids.
              return (window.__swGetCart ? window.__swGetCart(true) : fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }))
                .then(function (cartNow) {
                  var items = cartNow.items || [];
                  var giftTatOps = [];
                  items.forEach(function (giftItem) {
                    var isGift = giftItem.properties && giftItem.properties['_is_free_gift'] === 'true';
                    if (!isGift) return;
                    var parentVariantId = giftItem.properties['_gift_for_variant_ids'];
                    if (!parentVariantId) return;
                    var parent = items.find(function (it) { return String(it.variant_id) === String(parentVariantId); });
                    if (!parent || !parent.properties) return;
                    var parentTat = parent.properties['_delivery_tat'] || '';
                    var giftTat = giftItem.properties['_delivery_tat'] || '';
                    if (parentTat === giftTat) return;
                    var updatedGiftProps = Object.assign({}, giftItem.properties, { '_delivery_tat': parentTat });
                    giftTatOps.push(
                      fetch('/cart/change.js', {
                        method: 'POST',
                        cache: 'no-store',
                        headers: { 'Content-Type': 'application/json', 'X-SW-Silent-Cart-Sync': '1' },
                        body: JSON.stringify({ id: giftItem.key, quantity: giftItem.quantity, properties: updatedGiftProps })
                      }).catch(function (e) {
                        console.error('📍 Failed to sync _delivery_tat onto gift line', giftItem.key, ':', e);
                      })
                    );
                  });
                  if (!giftTatOps.length) return;
                  updatedCount += giftTatOps.length;
                  return Promise.all(giftTatOps);
                })
                .catch(function (e) {
                  console.error('📍 Gift _delivery_tat sync pass failed:', e);
                });
            })
            .then(function () {
              if (updatedCount > 0 || removedTitles.length > 0) {
                // Await the free-gift reconciliation HERE — before the
                // checkout busy loader is turned off (which happens in
                // the outer .then below) — so gift add/remove finishes
                // while the loader is still showing, instead of a beat
                // after it disappears. runGiftSync won't re-fire
                // price/update because the recheck above already
                // persisted every line's _api_price fresh (its cart
                // signature is unchanged, so its own price-sync short-
                // circuits and only reads cached gift data).
                var giftPromise = window.__swRunGiftSync
                  ? window.__swRunGiftSync()
                  : Promise.resolve();

                return giftPromise.then(function () {
                  document.dispatchEvent(new CustomEvent('sleep-setup:cart-changed'));
                  if (window.swRefreshCartDrawer) {
                    window.swRefreshCartDrawer({ delay: 300 });
                  } else {
                    document.dispatchEvent(new CustomEvent('cart:refresh'));
                    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
                  }
                });
              }
            });
        });
      })
      .catch(function (e) {
        console.error('📍 recheckAllCartItemsForPincode failed:', e);
      })
      .then(function () {
        recheckInFlight = false;
        setCheckoutBusy(false);
        if (recheckQueuedPincode) {
          var next = recheckQueuedPincode;
          recheckQueuedPincode = null;
          recheckAllCartItemsForPincode(next);
        }
      });
  }
  window.__swRecheckCartForPincode = recheckAllCartItemsForPincode;

  function getCurrentPincode() {
      return (localStorage.getItem('kpc_pincode') || '').trim();
  }

  function onPincodeChange() {
    var pincode = getCurrentPincode();
    if (!pincode) return;

    // 🆕 Agar ye pincode already process ho chuka hai, dobara API mat maaro —
    // LEKIN sirf tab jab cart mein koi item _not_available flagged na ho.
    // Warna ek baar galat/stale price aane par item HAMESHA ke liye stuck
    // reh jaata, kyunki same pincode dobara try karne pe bhi recheck kabhi
    // fire hi nahi hoti thi.
    if (pincode === lastCheckedPincode) {
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasUnavailable = (cart.items || []).some(function (it) {
            return it.properties && it.properties['_not_available'] === 'true';
          });
          if (!hasUnavailable) {
            console.log('📍 Pincode unchanged (' + pincode + ') — skipping duplicate recheck.');
            return;
          }
          console.log('📍 Pincode unchanged but cart has _not_available item(s) — forcing recheck anyway.');
          recheckAllCartItemsForPincode(pincode);
        })
        .catch(function () {});
      return;
    }
    lastCheckedPincode = pincode;

    console.log('📍 Pincode changed to', pincode, '— rechecking all cart items...');
    recheckAllCartItemsForPincode(pincode);
  }

  window.addEventListener('swCartPincodeChanged', onPincodeChange);
})();